const MOCK_EVENTS = [
  {
    id: 'trial-event-001',
    name: 'Annual Yoga Workshop',
    status: 'ongoing',
    image_url: '',
    venue_name: 'Acme Academy Hall',
    venue_city: 'Bengaluru',
    start_date_time: '2026-06-10T09:00:00Z',
    end_date_time: '2026-06-10T17:00:00Z',
    registration_status: 'open',
    seats_booked: 5,
    registration_end_date: '2026-06-08T23:59:00Z',
    form_link: 'https://pay.cofee.life/trial/event/yoga',
    capacity: 70,
    available_capacity: 65,
    total_capacity: 70
  },
  {
    id: 'trial-event-002',
    name: 'Swimming Championship',
    status: 'ongoing',
    image_url: '',
    venue_name: 'Aqua Sports Complex',
    venue_city: 'Bengaluru',
    start_date_time: '2026-06-15T08:00:00Z',
    end_date_time: '2026-06-15T18:00:00Z',
    registration_status: 'closed',
    seats_booked: 3,
    registration_end_date: '2026-06-12T23:59:00Z',
    form_link: 'https://pay.cofee.life/trial/event/swimming',
    capacity: 30,
    available_capacity: 27,
    total_capacity: 30
  },
  {
    id: 'trial-event-003',
    name: 'Dance Recital 2026',
    status: 'completed',
    image_url: '',
    venue_name: 'City Auditorium',
    venue_city: 'Bengaluru',
    start_date_time: '2026-04-20T16:00:00Z',
    end_date_time: '2026-04-20T20:00:00Z',
    registration_status: 'closed',
    seats_booked: 4,
    registration_end_date: '2026-04-18T23:59:00Z',
    form_link: 'https://pay.cofee.life/trial/event/dance',
    capacity: 40,
    available_capacity: 36,
    total_capacity: 40
  }
];

const MOCK_TICKETS: Record<
  string,
  {
    ticket_id: string;
    name: string;
    price: string;
    is_active: boolean;
    seats_booked: number;
    capacity: number;
    sub_ticket_count: number;
    has_sub_ticket: boolean;
    sub_tickets: {
      name: string;
      redeemed_count: number;
      redeemed_percentage: string;
    }[];
    description: string;
  }[]
> = {
  'trial-event-001': [
    {
      ticket_id: 'trial-ticket-001',
      name: 'General',
      price: '0',
      is_active: true,
      seats_booked: 3,
      capacity: 50,
      sub_ticket_count: 0,
      has_sub_ticket: false,
      sub_tickets: [],
      description: 'Free entry with yoga mat provided'
    },
    {
      ticket_id: 'trial-ticket-002',
      name: 'Premium',
      price: '500',
      is_active: true,
      seats_booked: 2,
      capacity: 20,
      sub_ticket_count: 0,
      has_sub_ticket: false,
      sub_tickets: [],
      description: 'Includes lunch and workshop kit'
    }
  ],
  'trial-event-002': [
    {
      ticket_id: 'trial-ticket-003',
      name: 'Participant',
      price: '300',
      is_active: true,
      seats_booked: 3,
      capacity: 30,
      sub_ticket_count: 0,
      has_sub_ticket: false,
      sub_tickets: [],
      description: 'Entry for all swimming events'
    }
  ],
  'trial-event-003': [
    {
      ticket_id: 'trial-ticket-004',
      name: 'Standard',
      price: '200',
      is_active: true,
      seats_booked: 4,
      capacity: 40,
      sub_ticket_count: 0,
      has_sub_ticket: false,
      sub_tickets: [],
      description: 'General admission seating'
    }
  ]
};

const MOCK_ATTENDEES: Record<
  string,
  {
    id: string;
    name: string;
    mobile: string;
    display_id: string;
    ticket_name: string;
    paid_amount: number;
    payment_status: string;
    check_in_status: string;
  }[]
> = {
  'trial-event-001': [
    {
      id: 'trial-attendee-001',
      name: 'Aarav Sharma',
      mobile: '+919870000001',
      display_id: 'EVT-001-001',
      ticket_name: 'General',
      paid_amount: 0,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-002',
      name: 'Priya Patel',
      mobile: '+919870000002',
      display_id: 'EVT-001-002',
      ticket_name: 'Premium',
      paid_amount: 500,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-003',
      name: 'Rohan Nair',
      mobile: '+919870000003',
      display_id: 'EVT-001-003',
      ticket_name: 'General',
      paid_amount: 0,
      payment_status: 'paid',
      check_in_status: 'not_checked_in'
    },
    {
      id: 'trial-attendee-004',
      name: 'Meera Reddy',
      mobile: '+919870000004',
      display_id: 'EVT-001-004',
      ticket_name: 'Premium',
      paid_amount: 500,
      payment_status: 'paid',
      check_in_status: 'not_checked_in'
    },
    {
      id: 'trial-attendee-005',
      name: 'Arjun Kumar',
      mobile: '+919870000005',
      display_id: 'EVT-001-005',
      ticket_name: 'General',
      paid_amount: 0,
      payment_status: 'paid',
      check_in_status: 'not_checked_in'
    }
  ],
  'trial-event-002': [
    {
      id: 'trial-attendee-006',
      name: 'Ananya Gupta',
      mobile: '+919870000006',
      display_id: 'EVT-002-001',
      ticket_name: 'Participant',
      paid_amount: 300,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-007',
      name: 'Vikram Menon',
      mobile: '+919870000007',
      display_id: 'EVT-002-002',
      ticket_name: 'Participant',
      paid_amount: 300,
      payment_status: 'paid',
      check_in_status: 'not_checked_in'
    },
    {
      id: 'trial-attendee-008',
      name: 'Sneha Iyer',
      mobile: '+919870000008',
      display_id: 'EVT-002-003',
      ticket_name: 'Participant',
      paid_amount: 300,
      payment_status: 'processing',
      check_in_status: 'not_checked_in'
    }
  ],
  'trial-event-003': [
    {
      id: 'trial-attendee-009',
      name: 'Karthik Singh',
      mobile: '+919870000009',
      display_id: 'EVT-003-001',
      ticket_name: 'Standard',
      paid_amount: 200,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-010',
      name: 'Divya Das',
      mobile: '+919870000010',
      display_id: 'EVT-003-002',
      ticket_name: 'Standard',
      paid_amount: 200,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-011',
      name: 'Rahul Joshi',
      mobile: '+919870000011',
      display_id: 'EVT-003-003',
      ticket_name: 'Standard',
      paid_amount: 200,
      payment_status: 'paid',
      check_in_status: 'already_checked_in'
    },
    {
      id: 'trial-attendee-012',
      name: 'Ishita Verma',
      mobile: '+919870000012',
      display_id: 'EVT-003-004',
      ticket_name: 'Standard',
      paid_amount: 200,
      payment_status: 'paid',
      check_in_status: 'cancelled'
    }
  ]
};

const ALL_ATTENDEES = Object.values(MOCK_ATTENDEES).flat();

// ── Event list (GET /branch/{branchId}/event) ──

export const getEventListMock = (
  page: number,
  limit: number,
  status: string,
  search: string
) => {
  let filtered = MOCK_EVENTS;

  if (status && status !== 'all') {
    filtered = filtered.filter((e) => e.status === status);
  }

  if (search) {
    const term = search.toLowerCase();
    filtered = filtered.filter((e) => e.name.toLowerCase().includes(term));
  }

  const start = page * limit;
  const slice = filtered.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: filtered.length,
      page,
      limit,
      last_page: start + limit >= filtered.length
    }
  };
};

// ── Event overview / details (GET /event/{eventId}/overview) ──

export const getEventDetailsMock = (eventId: string) => {
  const event = MOCK_EVENTS.find((e) => e.id === eventId) || MOCK_EVENTS[0];
  const tickets = MOCK_TICKETS[event.id] || MOCK_TICKETS['trial-event-001'];
  const attendees = MOCK_ATTENDEES[event.id] || [];

  const totalRevenue = attendees.reduce((sum, a) => sum + a.paid_amount, 0);

  return {
    event_id: event.id,
    name: event.name,
    image_url: event.image_url,
    venue_name: event.venue_name,
    venue_city: event.venue_city,
    registration_end_date_time: event.registration_end_date,
    start_date_time: event.start_date_time,
    end_date_time: event.end_date_time,
    form_link: event.form_link,
    total_registrations: attendees.length,
    total_ticket_sold: attendees.length,
    total_revenue: String(totalRevenue),
    tickets: tickets.map(({ description: _desc, ...ticket }) => ticket),
    status: event.status,
    discount_insights: {
      applied_coupon_count: 0,
      discount_redeemed: '0',
      percentage_registrations_with_discount: '0',
      active_coupon_count: 0,
      total_coupon_count: 0
    }
  };
};

// ── Attendee list (GET /event/{eventId}/attendee) ──

export const getEventAttendeeListMock = (
  eventId: string,
  page: number,
  limit: number,
  search: string
) => {
  let attendees = MOCK_ATTENDEES[eventId] || [];

  if (search) {
    const term = search.toLowerCase();
    attendees = attendees.filter(
      (a) =>
        a.name.toLowerCase().includes(term) ||
        a.mobile.includes(term) ||
        a.display_id.toLowerCase().includes(term)
    );
  }

  const start = page * limit;
  const slice = attendees.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: attendees.length,
      page,
      limit
    }
  };
};

// ── Attendee detail (GET /event/{eventId}/attendee/{attendeeId}) ──

export const getAttendeeDetailMock = (attendeeId: string) => {
  const attendee =
    ALL_ATTENDEES.find((a) => a.id === attendeeId) || ALL_ATTENDEES[0];

  return {
    name: attendee.name,
    mobile: attendee.mobile,
    event_form_submission: [
      {
        id: 1,
        field_name: 'Full Name',
        field_value: attendee.name,
        field_type: 'text',
        is_required: true,
        display_order: 1
      },
      {
        id: 2,
        field_name: 'Phone Number',
        field_value: attendee.mobile,
        field_type: 'mobile_number',
        is_required: true,
        display_order: 2
      },
      {
        id: 3,
        field_name: 'Email',
        field_value: `${attendee.name
          .toLowerCase()
          .replace(/\s/g, '.')}@example.com`,
        field_type: 'email_id',
        is_required: false,
        display_order: 3
      }
    ]
  };
};

// ── Event form details for edit (GET v1/event/{eventId}/form) ──

export const getEventFormDetailsMock = (eventId: string) => {
  const event = MOCK_EVENTS.find((e) => e.id === eventId) || MOCK_EVENTS[0];
  const tickets = MOCK_TICKETS[event.id] || MOCK_TICKETS['trial-event-001'];

  return {
    event_id: event.id,
    name: event.name,
    description: `Welcome to ${event.name}! Join us for an exciting experience.`,
    image_url: event.image_url,
    venue_name: event.venue_name,
    venue_address_line1: '12, MG Road',
    venue_address_line2: '',
    venue_city: event.venue_city,
    venue_state: 'Karnataka',
    venue_pincode: '560001',
    location_link: '',
    contact_name: 'Trial User',
    contact_email: 'trial@acmeacademy.com',
    contact_phone: '9876543210',
    contact_alternate_phone: '',
    start_date_time: event.start_date_time,
    end_date_time: event.end_date_time,
    registration_end_date_time: event.registration_end_date,
    additional_doc_url: '',
    status: event.status,
    registration_status: event.registration_status,
    event_tickets: tickets.map((t, i) => ({
      ticket_id: i + 1,
      name: t.name,
      price: t.price,
      is_active: t.is_active,
      description: t.description,
      post_booking_instructions: '',
      capacity: t.capacity,
      available_capacity: t.capacity - t.seats_booked,
      seats_booked: t.seats_booked,
      sub_tickets: []
    })),
    min_ticket_price: tickets
      .reduce((min, t) => {
        const p = parseFloat(t.price);
        return p < min ? p : min;
      }, parseFloat(tickets[0].price))
      .toString(),
    form_fields: [
      {
        form_id: 1,
        field_name: 'Full Name',
        field_type: 'text',
        is_required: true,
        is_active: true,
        display_order: 1
      },
      {
        form_id: 2,
        field_name: 'Phone Number',
        field_type: 'mobile_number',
        is_required: true,
        is_active: true,
        display_order: 2
      },
      {
        form_id: 3,
        field_name: 'Email',
        field_type: 'email_id',
        is_required: false,
        is_active: true,
        display_order: 3
      }
    ],
    event_registration_status: event.registration_status,
    event_status: event.status,
    is_ticket_email_enabled: true,
    sub_tickets: [],
    show_business_logo: true,
    is_attendee_details_required_per_ticket: false,
    max_tickets_per_booking: null
  };
};
